import { en, type ChromeMessages } from "./chrome_en.ts";

/** French web app chrome. Unlisted keys stay English (product names and tokens). */
export const fr: ChromeMessages = {
  ...en,
  appTitle: "intEHRgrator — Banc d'intégration",
  copyPrompt: "Copier l'invite",
  copyPromptTitle: "Copier l'invite d'IA avec les fichiers intégrés",
  callAi: "Appeler l'IA",
  callAiTitle: "Appeler l'IA configurée avec les outils de mappage (noms MCP / API d'agent)",
  aiMenuAria: "Aide de l'IA",
  menuCopyPrompt: "Copier l'invite",
  menuCallAi: "Appeler l'IA",
  menuAiCredentials: "Configurer les identifiants d'IA…",
  menuEmbedFiles: "Intégrer les fichiers dans l'invite",
  menuAttachFiles: "Joindre les fichiers dans le chat",
  menuBrowseUris: "Parcourir les URI (si disponibles)",
  menuAiCopyHeading: "copier/coller pour chat IA externe",
  menuAiOwnHeading: "Votre propre IA",
  menuAiDesktopHeading: "Bureau",
  menuLocalMcp: "Serveur MCP local…",
  localMcpTitle: "Serveur MCP local",
  localMcpIntro:
    "Démarrez ou arrêtez le serveur que votre IDE utilise pour modifier ce canevas. Copiez la configuration dans les réglages MCP de l'IDE. Laissez cette application ouverte.",
  localMcpRunning: "En cours — un IDE peut se connecter",
  localMcpStopped: "Arrêté — les IDE ne peuvent pas modifier ce canevas",
  localMcpStart: "Démarrer",
  localMcpStop: "Arrêter",
  localMcpUrlLabel: "URL de l'API agent",
  localMcpTokenLabel: "Jeton",
  localMcpNoToken: "Aucun jeton (bouclage local uniquement)",
  localMcpConfigLabel: "Configuration de l'IDE (mcp.json)",
  localMcpCopy: "Copier la configuration",
  localMcpCopied: "Configuration copiée",
  localMcpUnavailable: "Le serveur de bureau n'a pas répondu.",
  menuFile: "Fichier",
  menuAi: "IA",
  importAi: "Importer les suggestions d'IA",
  exampleSets: "Jeux d'exemples",
  exampleSetsTitle: "Charger un jeu d'exemples complet (Source, cible, mappage facultatif) depuis les URI du catalogue",
  exampleSetsMenuAria: "Choisir un jeu d'exemples",
  functions: "Fonctions",
  functionsTitle: "Enregistrer, charger ou proposer des fonctions Blockly ; parcourir la bibliothèque de fonctions GitHub",
  newProject: "Nouveau projet",
  loadProject: "Charger le projet",
  saveAs: "Enregistrer sous",
  exportProject: "Exporter le projet",
  importProject: "Importer le projet",
  betterForm: "Ouvrir le formulaire Better",
  betterFormTitle: "Le moteur Better sous licence reste dans ce navigateur. Téléversez-le dans la visionneuse s'il n'y est pas encore.",
  help: "Aide",
  helpTitle: "Tutoriel et signalement d'incidents",
  helpMenuAria: "Menu d'aide",
  userTutorial: "Tutoriel utilisateur",
  reportBug: "Signaler un bogue",
  requestFeature: "Demander une fonctionnalité",
  uiLanguageAria: "Langue de l'interface",
  showSource: "Source",
  source: "Source",
  clickToMapAria: "Cliquer pour mapper vers Handlebars",
  clickToMapHtml:
    "Cliquez sur un nœud du schéma Source ou d'une instance d'exemple pour le mapper dans le bloc Blockly sélectionné. Si un bloc de texte de code (LANG = Handlebars) ou un bloc de texte Handlebars est sélectionné, le clic insère un {{path}} VMS-Hbs au curseur. Maintenez Maj pour des {{#with}} / {{#each}} imbriqués. Sinon, le mode écoute remplit le bloc de requête Source en attente.",
  slideSourceAway: "Masquer Source",
  handlebarsHint: "Insertion Handlebars prête — cliquez sur un nœud Source pour {{path}} ; Maj+clic pour #with/#each imbriqués.",
  schemaFormatsAria: "Formats de schéma pris en charge",
  schemaFormatsHtml:
    "Pris en charge : JSON Schema, documents JSON ou XML, échantillons XSD, et Web Template openEHR, Composition JSON, ou un .t.json GitHub (les archétypes sont récupérés depuis le même dépôt).<br>Chargez depuis un fichier local, une URL, ou ▾ → Depuis un modèle GitHub….",
  loadSchema: "Charger le schéma",
  schemaMenuAria: "Autres options de chargement du schéma",
  examples: "Exemples",
  exampleFormatsAria: "Formats d'exemple pris en charge",
  exampleFormatsHtml:
    "Pris en charge : fichiers d'instance JSON ou XML.<br>Chargez un fichier, un dossier local, un dossier GitHub (▾), ou un seul fichier depuis une URL.",
  addExample: "+ Ajouter un exemple",
  exampleMenuAria: "Autres options de chargement d'exemples",
  mappingEditors: "Éditeurs de mappage",
  undo: "Annuler",
  redo: "Rétablir",
  expandAll: "Tout développer",
  expandAllTitle: "Développer tous les blocs imbriqués",
  collapseAll: "Tout réduire",
  collapseAllTitle: "Réduire tous les blocs imbriqués",
  expandChildren: "Développer les enfants",
  collapseChildren: "Réduire les enfants",
  useCodedText: "Utiliser du texte codé (DV_CODED_TEXT)",
  usePlainText: "Utiliser du texte simple (DV_TEXT)",
  followAgent: "Suivre l'agent",
  followAgentTitle: "Lorsque cette option est active, le canevas principal se centre sur les blocs qu'un agent vient de modifier",
  openViewer: "Ouvrir la fenêtre de visualisation",
  openViewerTitle: "Ouvrir la fenêtre de visualisation : canevas en direct, légende des agents et historique attribué",
  downloadJson: "Télécharger le JSON",
  downloadWorkspaceTitle: "Télécharger le JSON complet de l'espace Blockly (coordonnées et disposition comprises)",
  mappingViewsAria: "Vues texte de l'éditeur de mappage",
  mappingSpec: "Spécification de mappage",
  specLayoutAria: "Options d'affichage de la spécification",
  listView: "Vue liste (toutes les racines)",
  tabbedView: "Vue par onglets (par racine)",
  download: "Télécharger",
  downloadSpecTitle: "Télécharger le JSON complet de l'espace Blockly",
  downloadSpecAria: "Télécharger le JSON complet de l'espace Blockly",
  upload: "Téléverser",
  uploadSpecTitle: "Téléverser un fichier JSON d'espace Blockly",
  uploadSpecAria: "Téléverser un fichier JSON d'espace Blockly",
  specEditorActionsAria: "Actions de l'éditeur de spécification de mapping",
  searchSpecTitle: "Rechercher dans la spécification de mapping",
  searchSpecAria: "Rechercher dans la spécification de mapping",
  copySpecTitle: "Copier la spécification de mapping",
  copySpecAria: "Copier la spécification de mapping",
  scriptEditorActionsAria: "Actions de l'éditeur de script de conversion",
  searchScriptTitle: "Rechercher dans le script de conversion",
  searchScriptAria: "Rechercher dans le script de conversion",
  copyScriptTitle: "Copier le script de conversion",
  copyScriptAria: "Copier le script de conversion",
  downloadScriptAria: "Télécharger le script de conversion",
  testEditorActionsAria: "Actions de l'éditeur de résultat de test",
  searchTestTitle: "Rechercher dans le résultat du test",
  searchTestAria: "Rechercher dans le résultat du test",
  copyTestTitle: "Copier le résultat du test",
  copyTestAria: "Copier le résultat du test",
  downloadTestAria: "Télécharger le résultat du test de conversion",
  markWarned: "Marquer les facultatifs signalés",
  markWarnedTitle: "Marquer les arbres d'échafaudage facultatifs non mappés qui affichent un avertissement de contrainte",
  deleteMarked: "Supprimer les éléments marqués",
  deleteMarkedTitle: "Supprimer du canevas les nœuds cochés et leurs enfants",
  undoHistoryHint: "Astuce : ouvrez le canevas (observateur) pour l'historique attribué et la chronologie complète de l'agent.",
  undoLastEdit: "Annuler la dernière modification du canevas.",
  redoLastEdit: "Rétablir la modification du canevas.",
  railTarget: "Schéma cible",
  railTargetTitle: "Schéma cible",
  railScripts: "Scripts générés",
  railScriptsTitle: "Scripts de conversion générés",
  railTestTitle: "Exécutions de test de conversion",
  targetPreviews: "Cible et aperçus",
  targetFormatsAria: "Formats de cible pris en charge",
  targetFormatsHtml:
    "Pris en charge : OPT/OPT2 openEHR, Web Template, JSON Schema, XML Schema (XSD), ADL, modèles libres, ou un .t.json GitHub (les archétypes sont récupérés depuis le même dépôt).<br>Choisissez ensemble une cible et une carte de contexte par défaut. ▾ propose aussi fichier, URL, GitHub et actualisation non destructive.",
  loadTarget: "Charger la cible et la carte de contexte par défaut",
  loadTargetTitle: "Charger une cible et choisir une carte de contexte par défaut",
  targetMenuAria: "Autres options de chargement de la cible",
  modelLanguageAria: "Langue de l'ontologie du modèle cible",
  scriptFormatsAria: "Formats de script de conversion",
  scriptFormatsHtml:
    "L'aperçu de mappage interprète le mappage sans générer de script. Scripts de conversion (pour l'instant) : TypeScript, Java, Handlebars, XQuery et Go Template. TypeScript, Handlebars, Go Template et XQuery s'exécutent aussi dans le test de conversion. Java génère une classe Archie mais ne s'exécute pas dans le web app. Pour les cibles openEHR, l'instance JSON ou XML choisit comment XQuery sérialise la composition.<br>Télécharger dans l'éditeur de script enregistre le script généré. Le bouton Télécharger sur le test de conversion enregistre cette instance.",
  mappingPreview: "Aperçu du mappage",
  instance: "Instance openEHR",
  instanceTitle: "Forme d'instance openEHR souhaitée. L'export XQuery et le test de conversion utilisent cette sérialisation.",
  jsonInstance: "Instance JSON",
  xmlInstance: "Instance XML",
  slideTargetAway: "Masquer Cible et aperçus",
  tabTargetSchema: "Schéma cible",
  tabScripts: "Scripts de conversion générés",
  tabTest: "Exécutions de test de conversion",
  generatedScripts: "Scripts de conversion générés",
  downloadScriptTitle: "Télécharger le script de conversion",
  testRuns: "Exécutions de test de conversion",
  validateAs: "Valider comme",
  validateTitle: "Préréglage du désérialiseur JSON ehrtslib pour la validation du modèle",
  hybrid: "Hybride (souple)",
  defaultMode: "Par défaut",
  compact: "Mode compact",
  canonicalStrict: "Canonique strict",
  terse: "Concis",
  runTest: "Lancer le test",
  autoplay: "▶ Lecture automatique",
  pause: "⏸ Suspendre",
  downloadTestTitle: "Télécharger le résultat du test de conversion",
  ready: "Prêt",
  loadSchemaEmpty: "Chargez un fichier de schéma.",
  selectExampleTab: "Sélectionnez un onglet d'exemple.",
  addExamplesEmpty: 'Ajoutez des instances d\'exemple pour activer « Exécutions de test de conversion » dans Cible et aperçus',
  loadTargetEmpty: "Chargez un schéma ou un modèle cible.",
  statusNoTarget: "Aucune cible",
  statusTarget: "Cible : {id}",
  statusScript: "Script : {name}",
  statusNoExample: "Aucun exemple",
  statusExample: "Exemple : {name}",
  statusUnmapped: "{n} obligatoires non mappés",
  unsavedChanges: "modifications non enregistrées",
  autosavedAt: "enregistré automatiquement à {time}",
  functionsIntroHtml:
    "Enregistrez une fonction Blockly (définition + tables de décision) sur le disque, chargez-en une dans ce mappage, ou parcourez la bibliothèque de fonctions GitHub. Proposer ouvre un ticket de relecture — cela ne fusionne pas automatiquement.",
  onThisCanvas: "Sur ce canevas",
  loadFromDisk: "Charger depuis le disque…",
  functionLibrary: "Bibliothèque de fonctions",
  catalogUrl: "URL du catalogue",
  loadCatalog: "Charger le catalogue",
  close: "Fermer",
  nameInUse: "Nom déjà utilisé",
  cancel: "Annuler",
  replace: "Remplacer",
  rename: "Renommer",
  contributeTitle: "Proposer une fonction",
  contributeIntroHtml:
    "Ouvre un ticket GitHub sur <code>regionstockholm/intehrgrator</code> avec votre description et la définition de la fonction. Les mainteneurs relisent à la main.",
  functionName: "Fonction :",
  descriptionRequired: "Description (obligatoire)",
  contributePlaceholder: "Ce qu'elle renvoie, langue, table de décision, paramètres…",
  needGithubHtml:
    'Besoin d\'un compte GitHub ? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Créer un compte</a> ou <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">se connecter</a>, puis envoyer.',
  openGithubIssue: "Ouvrir un ticket GitHub",
  saveAsIntro: "Enregistrez l'espace de travail actuel sous un nom que vous pourrez recharger plus tard.",
  projectName: "Nom du projet",
  projectNamePlaceholder: "Mon projet d'intégration",
  save: "Enregistrer",
  loadProjectTitle: "Charger le projet",
  loadProjectIntro: "Sélectionnez un espace enregistré. Le chargement remplace le projet actuel.",
  loadFromUrl: "Charger depuis une URL",
  loadUrlHint: "Collez une URL https. Les pages de fichiers GitHub sont converties en contenu brut.",
  recentUrls: "URL récentes",
  load: "Charger",
  jointTitle: "Charger la cible et la carte de contexte par défaut",
  jointIntroHtml:
    "Choisissez ensemble une cible et une carte de contexte par défaut. Confirmer échafaude le <strong>squelette de modèle</strong> et les <strong>points par défaut</strong>. <strong>Nouveau</strong> charge la cible uniquement dans l'onglet Schéma cible pour que vous puissiez tirer les pastilles et les valeurs, puis Appliquer sur le bloc du canevas.",
  targetLegend: "Cible",
  noTargetYet: "Aucune cible sélectionnée pour l'instant.",
  fromFile: "Depuis un fichier…",
  useLoadedTarget: "Utiliser la cible chargée",
  targetUrl: "URL de la cible",
  fetchUrl: "Récupérer l'URL",
  mapLegend: "Carte de contexte par défaut",
  factoryMapHtml: "Fabrique openEHR (<code>defaults_openEHR_1</code>)",
  keepMap: "Conserver la carte déjà présente sur le canevas",
  newMap: "Nouveau (vide) — d'abord le schéma cible, puis Appliquer",
  browsedFile: "Fichier parcouru",
  browseMap: "Parcourir un fichier de carte…",
  loadAndScaffold: "Charger et échafauder",
  loadIntoSchema: "Charger dans le schéma cible",
  refreshReport: "Rapport d'actualisation",
  copyMergePrompt: "Copier l'invite de fusion",
  aiCredentialsTitle: "Identifiants d'IA",
  aiCredentialsIntroHtml:
    'Point de terminaison de chat compatible OpenAI, facultatif, pour que <strong>Appeler l\'IA</strong> puisse mapper depuis le web app. Les identifiants restent dans ce navigateur uniquement — pas dans le paquet du projet. <strong>Appeler l\'IA</strong> peut utiliser les mêmes outils de mappage que MCP / l\'API HTTP de l\'agent (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). Un IDE assisté par IA avec MCP local reste un chemin distinct et tout aussi valable. Pages pas à pas : <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">Identifiants Appeler l\'IA</a>.',
  provider: "Fournisseur",
  customEndpoint: "Point de terminaison compatible OpenAI personnalisé",
  getApiKey: "Obtenir une clé d'API",
  providerDocs: "Documentation du fournisseur",
  endpoint: "Point de terminaison",
  apiKey: "Clé d'API",
  model: "Modèle",
  clear: "Effacer",
  defaultsTitle: "Carte de contexte par défaut",
  defaultsIntro: "Chargez une carte enregistrée, parcourez un fichier ou une URL, téléchargez la carte de contexte par défaut unique, ou enregistrez la carte du canevas sous un nom.",
  browseFile: "Parcourir un fichier…",
  loadUrlBtn: "Charger l'URL",
  downloadFile: "Télécharger le fichier…",
  saveAsEllipsis: "Enregistrer sous…",
  saveDefaultsTitle: "Enregistrer la carte de contexte par défaut sous",
  saveDefaultsIntro: "Enregistrez la carte de contexte par défaut actuelle sous un nom que vous pourrez choisir plus tard.",
  nameLabel: "Nom",
  hardcodeTitle: "Figer une entrée de la carte de contexte par défaut",
  hardcodeIntroHtml:
    "Choisissez une clé de carte à <strong>intégrer</strong> sur le canevas. Chaque recherche <code>get defaults key …</code> de cette clé est remplacée par une copie de la valeur de cette carte de contexte par défaut. Ensuite, ces emplacements ne lisent plus l'argument <code>defaults</code> au moment de la conversion — ils utilisent le bloc figé. La carte elle-même reste inchangée, pour que vous puissiez figer d'autres clés plus tard ou conserver l'entrée pour les recherches restantes.",
  importAiTitle: "Importer les suggestions d'IA",
  importAiIntroHtml:
    "Collez le JSON du chat d'IA (un objet brut ou une balise <code>intehrgrator-suggestions</code>). L'import est validé par rapport au JSON Schema des suggestions ; les erreurs restent visibles ici et peuvent être recopiées vers l'IA.",
  suggestions: "Suggestions d'IA",
  pasteClipboard: "Coller le presse-papiers",
  copyErrorsForAi: "Copier les erreurs pour l'IA",
  copied: "Copié",
  importAction: "Importer",
  notRecommended: "Pas sur la version recommandée",
  bleedingEdgeHtml:
    'Vous préférez expérimenter ? La version de pointe (mise à jour à chaque changement de <code>main</code>) est toujours à <a id="recommended-version-bleeding-edge-link" href="#">la racine du site</a>.',
  newHereHtml:
    'Nouveau ici ? Lisez le <a id="recommended-version-tutorial-link" href="#">tutoriel</a> ou le <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "Ne plus afficher ceci pour cette version",
  dismiss: "Fermer",
  defaultsBlockAria: "À propos de la carte de contexte par défaut",
  defaultsBlockHtml:
    "La <strong>carte de contexte par défaut</strong> est la table unique du canevas que vous rédigez ici. Au <em>moment de la conversion</em>, les scripts générés la reçoivent comme argument <code>defaults</code>, indexé par <strong>clé d'exécution</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> les recherche. Le code d'exécution peut fusionner ce sac avec des valeurs par message, d'autres cartes nommées et des grilles de feuilles — la carte du canevas est la base réutilisable, pas des littéraux figés dans chaque emplacement.<br>Les <strong>cibles d'échafaudage</strong> (pastilles) sont des chemins RM d'écriture uniquement, pas des clés d'exécution : <code>Class.attribute</code> (p. ex. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), chemins d'ancêtres et jokers (<code>*.language</code> éclaire chaque emplacement de langue). La pastille la plus spécifique l'emporte lorsque plusieurs correspondent. Pastilles vides → une clé uniquement d'exécution qui n'éclaire rien. Les clés en trop restent disponibles pour les recherches de carte même si elles n'éclairent aucun emplacement.<br>Confirmer, <strong>Appliquer la carte de contexte par défaut</strong>, ou une actualisation ultérieure de la cible relient les <strong>points par défaut</strong>. Les modifications de valeur sont visibles dans le test. Un emplacement déjà mappé depuis la source n'est pas remplacé.<br>Le dossier ouvre le chargement et l'enregistrement : choisir une carte enregistrée dans ce navigateur, parcourir un fichier JSON, charger une URL, enregistrer une copie nommée, ou télécharger la carte actuelle en JSON pour la recharger plus tard.",
  decisionBlockAria: "À propos des tables de décision",
  decisionBlockHtml:
    "La <strong>table de décision</strong> est une grille de règles nommée dans l'onglet Tableaux et feuilles : colonnes de condition (égalité, indifférent <code>—</code>) et colonnes de sortie (valeurs simples ou extraits VMS-Mustache). La grille possède les noms et les types de colonnes ; les clés de la carte d'entrées de ce bloc restent synchronisées.<br>Branchez à droite une carte d'entrées (clés = en-têtes de condition). La liste de sortie renvoie une colonne typée (🔤 chaîne, 🔢 nombre, ✓ booléen), ou <em>toutes les sorties</em> comme carte (↦). Changer ce type peut débrancher le bloc ; annuler/rétablir sur le canevas le restaure.<br>La politique de correspondance (FIRST / UNIQUE / COLLECT) est dans l'onglet Tableaux et feuilles. Aplatissez les sources imbriquées dans la carte d'entrées (ou via des variables) avant l'évaluation.",
  fromUrl: "Depuis une URL…",
  refreshFromFile: "Actualiser depuis un fichier…",
  refreshFromUrl: "Actualiser depuis une URL…",
  noRecentUrls: "Aucune URL récente pour l'instant.",
  removeFromHistory: "Retirer {url} de l'historique",
  enterUrl: "Saisissez une URL.",
  refreshKindFromUrl: "Actualiser {kind} depuis une URL",
  refreshUrlHint: "Rechargez ce fichier depuis une URL sans effacer les mappages du canevas. Les avertissements listent les emplacements ou chemins qui pourraient ne plus convenir.",
  kindExample: "exemple",
  kindTarget: "cible",
  kindSource: "Source",
  fromLocalFolder: "Depuis un dossier local…",
  fromGithubFolder: "Depuis un dossier GitHub…",
  fromGithubTemplate: "Depuis un modèle GitHub…",
  loadSchemaFromUrl: "Charger le schéma depuis une URL",
  loadSchemaUrlHint: "JSON, XML, XSD, ou un modèle .t.json GitHub (les archétypes sont récupérés depuis le même dépôt). Les pages de fichiers GitHub sont converties en contenu brut.",
  recentSchemaUrls: "URL de schéma récentes",
  githubTemplateTitle: "Charger un modèle openEHR depuis GitHub",
  githubTemplateHint: "Collez une URL blob ou raw GitHub vers un .t.json Better (ou .adl / .opt). Les archétypes dépendants sont tirés de la même branche du dépôt.",
  githubTemplateOpenTitle: "Ouvrir un modèle openEHR depuis GitHub",
  addExampleFromUrl: "Ajouter un exemple depuis une URL",
  addExampleUrlHint: "Instance JSON ou XML. Les pages de fichiers GitHub sont converties en contenu brut.",
  recentExampleUrls: "URL d'exemple récentes",
  githubFolderTitle: "Ajouter des exemples depuis un dossier GitHub",
  githubFolderHint: "Collez une URL d'arborescence GitHub vers un dossier. Tous les fichiers JSON et XML sous ce chemin sont chargés.",
  loadTargetFromUrl: "Charger la cible depuis une URL",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema, ou un .t.json GitHub. Les pages de fichiers GitHub sont converties en contenu brut.",
  recentTargetUrls: "URL de cible récentes",
  loadingCatalog: "Chargement du catalogue…",
  exampleSetsHeading: "Jeux d'exemples",
  noExampleSets: "Aucun jeu d'exemples dans le catalogue",
  catalog: "Catalogue",
  bundledCatalog: "Catalogue d'essai inclus",
  ehrtslibCatalog: "Catalogue ehrtslib (GitHub)…",
  loadCatalogFromUrl: "Charger le catalogue depuis une URL…",
  catalogUrlPrompt: "URL JSON du catalogue de jeux d'exemples",
  confirmLoadExampleSet: "Charger ce jeu d'exemples ? L'espace de travail actuel sera remplacé. Les modifications non enregistrées peuvent être perdues.",
  confirmNewProject: "Commencer un nouveau projet ? L'espace de travail actuel sera effacé. Les modifications non enregistrées peuvent être perdues.",
  confirmNewEmpty: "Commencer un projet vide ?",
  confirmLoadProject: "Charger ce projet ? L'espace de travail actuel sera remplacé.",
  noSavedProjects: "Aucun projet enregistré pour l'instant. Utilisez Enregistrer sous ou attendez l'enregistrement automatique.",
  lastAutosave: "Dernier enregistrement automatique",
  savedProject: "Projet enregistré",
  defaultsUnavailable: "Catalogue des valeurs par défaut indisponible : {detail}",
  noSavedMaps: "Aucune carte de contexte par défaut enregistrée pour l'instant. Utilisez Enregistrer sous, Télécharger, Parcourir un fichier, ou une URL.",
  savedMap: "Carte enregistrée",
  noHardcodeEntries: "La carte de contexte par défaut n'a pas encore d'entrées à figer.",
  selectedFile: "Sélectionné : {name}",
  usingLoaded: "Fichier chargé : {name}",
  fetchedFile: "Récupéré : {name}",
  browsedFileLabel: "Fichier parcouru : {name}",
  pasteTargetUrl: "Collez d'abord une URL de cible.",
  popupBlockedSvg: "Fenêtre bloquée — un SVG a été téléchargé à la place.",
  popupBlockedEmpty: "Fenêtre bloquée et le canevas est vide.",
  openedObserver: "Observateur d'agent / instantané du canevas ouvert.",
  betterPopupBlocked: "Impossible d'ouvrir la visionneuse Better. Autorisez les fenêtres contextuelles pour ce site.",
  schemaMismatch: "Écart de schéma :",
  conversionFailed: "La conversion a échoué :",
  templateValidation: "Validation du modèle :",
  noWorkspace: "Aucun espace Blockly",
  noFunctionsOnCanvas: "Aucune fonction sur le canevas. Extraire en fonction, ou charger depuis la bibliothèque.",
  contribute: "Proposer",
  loadCatalogBrowse: "Chargez le catalogue pour parcourir les fonctions sélectionnées.",
  catalogNoFunctions: "Le catalogue ne contient aucune fonction.",
  loadingLibrary: "Chargement de la bibliothèque de fonctions…",
  fnReturnsValue: "{sig} → valeur",
  pasteJsonFirst: "Collez d'abord le JSON de l'IA (ou une balise intehrgrator-suggestions)",
  clipboardEmpty: "Le presse-papiers est vide ou illisible dans ce navigateur",
  noMatches: "Aucune correspondance",
  searchPlaceholder: "Rechercher…",
  filterList: "Filtrer la liste",
  historyTimeline: "Chronologie de l'historique",
  historyIntro: "Faites défiler pour prévisualiser ; un retour arrière tronque les entrées suivantes. L'annulation par correctif renvoie du JSON intehrgrator-suggestions v2.",
  seqLabel: "Séquence",
  previewAtSeq: "Aperçu à la séquence",
  rollbackHere: "Revenir ici (destructif)",
  copyPatchUndo: "Copier l'invite d'annulation par correctif",
  timelineDesktopOnly: "La chronologie de l'API d'agent n'est disponible que dans l'application de bureau.",
  timelineUnavailable: "API d'agent indisponible — chronologie en attente.",
  noHistoryYet: "Aucun historique pour l'instant.",
  selectHistoryPoint: "Sélectionnez un point de l'historique.",
  downloadDiscardedConfirm: "Télécharger la branche écartée (.intehrgrator) avant de continuer ?",
  noBundleExport: "Aucune donnée de paquet à exporter pour la branche écartée.",
  downloadedDiscarded: "Branche écartée téléchargée.",
  agentsHeading: "Agents connectés",
  projectLoaded: "Projet chargé",
  newProjectStatus: "Nouveau projet",
  projectNotFound: "Projet introuvable",
  projectImported: "Projet importé",
  restoredMapping: "Mappage précédent restauré",
  blocklyMustBeObject: "Le JSON Blockly doit être un objet",
  exampleDropJsonXml: "Déposer des exemples : fichiers JSON ou XML uniquement",
  listeningSourceQuery: "Écoute du chemin Source → requête Source",
  appliedDefaults: "Carte de contexte par défaut appliquée",
  refreshPromptCopied: "Invite de fusion copiée",
  callingAi: "Appel de l'IA…",
  providerRejectedTools: "Le fournisseur a refusé les outils de mappage ; nouvel essai avec le JSON de suggestions…",
  aiCredentialsCleared: "Identifiants d'IA effacés",
  aiCredentialsSaved: "Identifiants d'IA enregistrés dans ce navigateur",
  saveAiOrCopy: "Enregistrez les identifiants d'IA pour appeler l'IA, ou utilisez Copier l'invite.",
  loadTargetFirst: "Chargez d'abord une cible dans le schéma cible, puis appliquez la carte de contexte par défaut.",
  targetNodeMissing: "Ce nœud du schéma cible n'est pas dans la cible chargée.",
  dropLeafHint: "Déposez une feuille sur des pastilles d'échafaudage, un sous-arbre sur une prise de valeur, ou sur le canevas vide.",
  emptyMapReady: "Carte de contexte par défaut vide prête : faites glisser depuis le schéma cible, puis appliquez.",
  pickTargetFirst: "Choisissez d'abord un fichier ou une URL de cible.",
  corsCallAiHint: "Le CORS du navigateur bloque souvent les fournisseurs cloud depuis GitHub Pages. Utilisez l'application de bureau (elle relaie Appeler l'IA), activez CORS sur un serveur local (Ollama / LM Studio), ou utilisez Copier l'invite.",
  savedAs: "Enregistré sous « {name} »",
  loadedSchema: "Schéma {name} chargé",
  loadedBlockly: "Mappage Blockly {name} chargé",
  loadedTargetIntoSchema: "Cible {format} {id} chargée dans le schéma cible (pas encore d'échafaudage produit)",
  loadedTarget: "Cible {format} {id} chargée",
  loadedFunctionLibrary: "Bibliothèque de fonctions chargée ({n})",
  loadedFunction: "Fonction {name} chargée",
  loadedExampleCatalog: "Catalogue de jeux d'exemples chargé ({n} {sets})",
  setSingular: "jeu",
  setPlural: "jeux",
  loadedExampleSet: "Jeu d'exemples « {name} » chargé",
  exampleSetFailed: "Le jeu d'exemples « {name} » a échoué : {detail}",
  addedExample: "Exemple {name} ajouté",
  addedExampleMismatch: "Exemple {name} ajouté avec {n} {mismatch} de schéma",
  mismatchSingular: "écart",
  mismatchPlural: "écarts",
  addedExamples: "{n} exemples ajoutés",
  addedExamplesMismatch: "{n} exemples ajoutés avec {m} {mismatch} de schéma",
  aiPromptCopied: "Invite d'IA copiée ({delivery})",
  listeningSlot: "Écoute du chemin Source → {slot}",
  mappedWhat: "{what} mappé",
  mappedSourceQuery: "Requête Source {xpath} mappée",
  importSummary: "Import : {applied} appliqués, {loops} boucles, {skipped} ignorés, {errors} erreurs{schema}",
  importSchemaNote: ", {n} de schéma",
  importFailed: "L'import a échoué : {detail}",
  targetLoadFailed: "Échec du chargement de la cible : {detail}",
  exampleLoadFailed: "Échec du chargement de l'exemple : {detail}",
  exampleFolderFailed: "Échec du chargement du dossier d'exemples : {detail}",
  functionCatalogFailed: "Le catalogue de la bibliothèque de fonctions a échoué : {detail}",
  exampleCatalogFailed: "Le catalogue de jeux d'exemples a échoué : {detail}",
  blocklyParseFailed: "Impossible de lire le JSON Blockly : {detail}",
  couldNotLoad: "Impossible de charger {name} : {detail}",
  autosaveFailed: "L'enregistrement automatique a échoué : {detail}",
  modelLanguageStatus: "Langue du modèle : {language}",
  refreshedClean: "{kind} {name} actualisé sans conflit de mappage.",
  refreshedWithWarnings: "{kind} actualisé {previous} → {next}",
  warningCount: "{n} {warnings} :",
  warningSingular: "avertissement",
  warningPlural: "avertissements",
  loadedGithubTemplate: "Modèle GitHub {id} chargé ({n} fichiers){extra}",
  loadedGithubSchema: "Schéma GitHub {id} chargé ({n} fichiers){extra}",
  warningsParen: " ({n} avertissements)",
  callAiFailed: "Appeler l'IA a échoué : {detail}",
  scaffoldTarget: "Cible d'échafaudage {path} (cliquez sur la pastille pour basculer *.)",
  nestedOnMap: "{label} imbriqué dans la carte de contexte par défaut",
  addedMapEntry: "Entrée {key} ({path}) ajoutée à la ligne {row}",
  addedFromTarget: "{label} ajouté depuis le schéma cible",
  addedSource: "Source {xpath} ajoutée",
  taskLoadGithub: "Charger le modèle clinique depuis GitHub",
  taskLoadAndScaffold: "Charger la cible et échafauder",
  taskLoadExampleSet: "Charger le jeu d'exemples",
  taskLoadTarget: "Charger la cible",
  taskLoadSchema: "Charger le schéma Source",
  taskLoadMapping: "Charger le mappage",
  taskLoadSheets: "Charger les feuilles",
  taskLoadDefaults: "Charger la carte par défaut",
  taskParseUrl: "Analyser l'URL GitHub",
  taskIndexTree: "Lister les fichiers du dépôt",
  taskFetchFiles: "Récupérer les fichiers du modèle clinique",
  taskParseModels: "Analyser les modèles et les archétypes",
  taskResolveOpt: "Résoudre le modèle opérationnel",
  taskScaffold: "Échafauder le squelette de modèle",
  taskGenerate: "Générer le script de conversion",
  taskLoadExampleN: "Charger l'exemple {n}",
  appDescription: "intEHRgrator — banc d'intégration visuel pour mapper des données Source vers openEHR",
  loadedColon: "Chargé : {name}",
  savedColon: "Enregistré : {name}",
  noMappingConflicts: "Aucun conflit de mappage.",
  refreshReportLine: "{kind} : {previous} → {next}",
  refreshWarningCount: "{n} avertissement(s) :",
  hardcodedLookups: "« {key} » figé dans {n} {lookups}",
  lookupSingular: "recherche",
  lookupPlural: "recherches",
  noDefaultsLookups: "Aucune recherche maps_get(\"defaults\", \"{key}\") sur le canevas",
  callAiResult: "Appeler l'IA : {applied} appliqués · {errors} erreurs{extra}",
  functionLibraryCount: "Bibliothèque de fonctions : {n} {functions}",
  functionSingular: "fonction",
  functionPlural: "fonctions",
  renamedFromParen: " (renommée depuis {name})",
  savedBundle: "{name} enregistré",
  descriptionForFunction: "Description de la fonction « {name} » (facultatif) :",
  clashExist: "{bits} existent déjà. Renommer conserve les deux (par défaut). Remplacer écrase la définition existante.",
  functionQuoted: "Fonction « {name} »",
  decisionQuoted: "Table de décision « {name} »",
  andWord: "et",
  openedContributionIssue: "Ticket de contribution ouvert pour {name}",
  openedGithubForm: "Formulaire de nouveau ticket GitHub ouvert pour {name}",
  entrySummary: "{description} Paramètres : {params}. Tables de décision : {tables}.",
  recommendedFrozen: "Vous utilisez intEHRgrator {current}, qui n'est pas la version recommandée pour les utilisateurs finaux ({recommended}).",
  recommendedBleeding: "Vous utilisez la version de pointe (mise à jour à chaque changement de main), et non la version stable recommandée ({recommended}).",
  goToRecommended: "Aller à la version recommandée ({tag})",
  previewingSeq: "Aperçu de la séquence {n}…",
  previewLoadedSeq: "Aperçu chargé pour la séquence {n} (lecture seule ; le canevas principal ne change pas).",
  rollbackAsk: "Revenir à la séquence {seq} ?\n\n{n} entrées ultérieures seront écartées.\n\nTélécharger la branche écartée (.intehrgrator) avant de continuer ?",
  confirmRollback: "Confirmer le retour destructif à la séquence {seq} ?",
  rolledBackSeq: "Retour à la séquence {n}. Le canevas principal va se synchroniser.",
  patchPromptCopied: "Invite de correctif copiée (intehrgrator-suggestions v2). Appliquer avec import_suggestions.",
  noAgentsYet: "Aucun agent connecté pour l'instant.",
  optionalAttributes: "Attributs facultatifs…",
  openViewerMenu: "Ouvrir la fenêtre de visualisation…",
  aiChatHistoryTrimmed: "Des tours anciens du chat ont été retirés pour que la requête reste sous {limit} tokens (l'API renvoie tout le chat à chaque étape) ; ce message joint à nouveau le contexte du projet.",
  aiChatHistoryFull: "Rien n'a été envoyé : l'historique du chat fait environ {tokens} tokens, au-dessus de la limite de {limit} pour ce modèle, et tout l'historique part avec chaque requête. Comment voulez-vous continuer ?",
  aiChatHistoryTrimChoice: "Continuer avec l'historique raccourci",
  aiChatHistoryRecapChoice: "Nouveau chat avec résumé",
  aiChatHistoryCancelChoice: "Annuler",
  aiChatHistoryRecapStarted: "Nouveau chat démarré. Un résumé du chat précédent (vos messages, les réponses et les mappings) part avec votre message, avec le contexte du projet.",
  aiChatHistoryCancelled: "Non envoyé. Votre message est toujours dans la zone de saisie.",
  aiChatStorageTrimmed: "Ce chat dépasse ce que le navigateur enregistre ({limit} caractères). Cette page garde tout le chat, mais après un rechargement seuls les tours les plus récents restent.",
};
